/* eslint-disable */
import ko from 'knockout';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var ViewModel = function (model) {
  Base.call(this);
  this.selectedEntityCount(model.get('selectedEntityCount'));
  this.titleText = ko.computed(function () {
    return i18n.getString('BulkEdit_Campaign_ChangeRsaAutoAssets').replace('{0}', this.selectedEntityCount());
  }, this);
  this.isRsaAutoAssetsSettingChecked = ko.observable(false);
  this.showPreviewButton(false);
};
export default ViewModel;

